var CONSTANTS = {
  q_dpr1: 75,
  q_dpr2: 50,
  q_dpr3: 35,
  q_dpr4: 23,
  q_dpr5: 20
};
export default CONSTANTS;
//# sourceMappingURL=constants.js.map